import { Stack, Text } from '@chakra-ui/react'
import { useState } from 'react'

import ButtonNavigation from 'components/button-navigation'
import Heading from 'components/heading'
import Input from 'components/input'
import NotificationHero from 'components/notification-hero'
import { isValidPassword } from 'utils/string-utils'

export type PasswordResetCallback = {
  resetCode: string
  newPassword: string
}

type Props = {
  username?: string
  loading: boolean
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
  callback: ({ resetCode, newPassword }: PasswordResetCallback) => void
  isForgot?: boolean
}

const PasswordReset = ({ username, isForgot, loading, setLoading, callback }: Props) => {
  const [resetCode, setResetCode] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmNewPassword, setConfirmNewPassword] = useState('')

  const onResetPassword = () => {
    setLoading(true)
    callback({ resetCode, newPassword })
  }

  return (
    <>
      <Heading as="h1" text="Password Reset" />
      {isForgot && (
        <NotificationHero
          status="success"
          title={`Code has been sent to ${username}. If you do not receive the code promptly, please check your junk or spam folder.`}
          icon={['fas', 'circle-check']}
        />
      )}
      <Stack direction="column" spacing="12px">
        <Heading as="h2" text="Change your password" />
        <Text>Create your new password below.</Text>
      </Stack>
      {isForgot && (
        <Input
          type="text"
          label={{ text: 'Code' }}
          caption="We sent this to you via email"
          isError={!resetCode}
          value={resetCode}
          onChange={evt => setResetCode(evt.target.value)}
        />
      )}
      <Input
        type="password"
        label={{ text: 'New password' }}
        caption="Password must be 8+ characters in length and contain at least 1 number, 1 uppercase & lowercase letter, and 1 special character"
        isError={!isValidPassword(newPassword)}
        value={newPassword}
        onChange={evt => setNewPassword(evt.target.value)}
      />
      <Input
        type="password"
        label={{ text: 'Confirm new password' }}
        value={confirmNewPassword}
        isError={newPassword !== confirmNewPassword}
        onChange={evt => setConfirmNewPassword(evt.target.value)}
      />
      <ButtonNavigation
        w="100%"
        type="progress"
        text="Change Password"
        isDisabled={
          (isForgot && !resetCode) ||
          !newPassword ||
          !confirmNewPassword ||
          !isValidPassword(newPassword) ||
          newPassword !== confirmNewPassword ||
          loading
        }
        onClick={onResetPassword}
      />
    </>
  )
}

export default PasswordReset
